export default "__VITE_ASSET__CD26tl_S__"